
































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";

declare let google: any;
const geocoder = new google.maps.Geocoder();

@Component
export default class MapsGenerator extends Vue {
  map: any;
  mapHeight = 400;
  mapWidth = null;
  street = "";
  plz = "";
  city = "";
  lat = "";
  lng = "";
  zoom = 15;
  mapType = "roadmap";
  mapStyles: any = {
    width: "100%",
    height: "420px",
  };
  mapOptions: any = {
    center: { lat: 51.3363, lng: 7.47149 },
    zoom: this.zoom,
    mapTypeControl: false,
    clickableIcons: false,
    scrollwheel: false,
    gestureHandling: "greedy",
    class: "map-marker",
    mapTypeId: this.mapType,
  };
  apiKey = "";
  generateCodeString = "";
  errors: string[] = [];
  mapMarkers = [
    {
      icon: "fas fa-map-marker-alt",
      path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
    },
    {
      icon: "fad fa-map-marker-alt",
      path: "M192 0C86 0 0 86 0 192c0 77.41 27 99 172.27 309.67a24 24 0 0 0 39.46 0C357 291 384 269.41 384 192 384 86 298 0 192 0zm0 288a96 96 0 1 1 96-96 96 96 0 0 1-96 96z M192 256a64 64 0 1 1 64-64 64 64 0 0 1-64 64z",
    },
    {
      icon: "fas fa-map-marker",
      path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z",
    },
    {
      icon: "fas fa-map-marker-exclamation",
      path: "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 9.6 12.8 28.8 12.8 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm0 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.44-110.41c-.82 8.18-7.7 14.41-15.92 14.41h-19.04c-8.22 0-15.1-6.23-15.92-14.41l-12.8-128c-.94-9.42 6.45-17.59 15.92-17.59h44.64c9.47 0 16.86 8.17 15.92 17.59l-12.8 128z",
    },
    {
      icon: "fa-solid fa-location-check",
      path: "M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM288.1 160.1C298.3 151.6 298.3 136.4 288.1 127C279.6 117.7 264.4 117.7 255 127L160 222.1L120.1 183C111.6 173.7 96.4 173.7 87.03 183C77.66 192.4 77.66 207.6 87.03 216.1L143 272.1C152.4 282.3 167.6 282.3 176.1 272.1L288.1 160.1z",
    },
    {
      icon: "fas fa-map-marker-plus",
      path: "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 9.6 12.8 28.8 12.8 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm112 200c0 8.84-7.16 16-16 16h-72v72c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-72H96c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h72V96c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v72h72c8.84 0 16 7.16 16 16v16z",
    },
    {
      icon: "fa-solid fa-location-minus",
      path: "M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM120 168C106.7 168 96 178.7 96 192C96 205.3 106.7 216 120 216H264C277.3 216 288 205.3 288 192C288 178.7 277.3 168 264 168H120z",
    },
    {
      icon: "fas fa-map-marker-times",
      path: "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 9.6 12.8 28.8 12.8 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm84.85 242.91c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L192 225.94l-50.91 50.91c-6.25 6.25-16.38 6.25-22.63 0l-11.31-11.31c-6.25-6.25-6.25-16.38 0-22.63L158.06 192l-50.91-50.91c-6.25-6.25-6.25-16.38 0-22.63l11.31-11.31c6.25-6.25 16.38-6.25 22.63 0L192 158.06l50.91-50.91c6.25-6.25 16.38-6.25 22.63 0l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63L225.94 192l50.91 50.91z",
    },
    {
      icon: "fa-solid fa-location-pen",
      path: "M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM276.8 107C262.1 92.31 238.2 92.31 223.5 107L208.6 121.1L261.9 175.3L276.8 160.4C291.5 145.6 291.5 121.8 276.8 107V107zM105.6 231.4L96.48 268C95.12 273.5 96.71 279.3 100.7 283.2C104.7 287.2 110.4 288.8 115.9 287.4L152.5 278.3C158.1 276.9 163.3 273.1 167.4 269.9L239.3 197.9L185.1 144.6L114.1 216.5C109.1 220.6 107 225.8 105.6 231.4H105.6z",
    },
    {
      icon: "fa-solid fa-location-smile",
      path: "M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM128 192C145.7 192 160 177.7 160 160C160 142.3 145.7 128 128 128C110.3 128 96 142.3 96 160C96 177.7 110.3 192 128 192zM256 128C238.3 128 224 142.3 224 160C224 177.7 238.3 192 256 192C273.7 192 288 177.7 288 160C288 142.3 273.7 128 256 128zM128.6 244.9C122.5 235.7 110.1 233.2 100.9 239.4C91.72 245.5 89.23 257.9 95.36 267.1C106.9 284.4 140.9 316 192 316C243.1 316 277.1 284.4 288.6 267.1C294.8 257.9 292.3 245.5 283.1 239.4C273.9 233.2 261.5 235.7 255.4 244.9C249.1 254.3 226.3 276 192 276C157.7 276 134.9 254.3 128.6 244.9z",
    },
    {
      icon: "fa-solid fa-map-pin",
      path: "M320 144C320 223.5 255.5 288 176 288C96.47 288 32 223.5 32 144C32 64.47 96.47 0 176 0C255.5 0 320 64.47 320 144zM192 64C192 55.16 184.8 48 176 48C122.1 48 80 90.98 80 144C80 152.8 87.16 160 96 160C104.8 160 112 152.8 112 144C112 108.7 140.7 80 176 80C184.8 80 192 72.84 192 64zM144 480V317.1C154.4 319 165.1 319.1 176 319.1C186.9 319.1 197.6 319 208 317.1V480C208 497.7 193.7 512 176 512C158.3 512 144 497.7 144 480z",
    },
    {
      icon: "fa-light fa-map-pin",
      path: "M112 160C103.2 160 96 152.8 96 144C96 99.82 131.8 64 176 64C184.8 64 192 71.16 192 80C192 88.84 184.8 96 176 96C149.5 96 128 117.5 128 144C128 152.8 120.8 160 112 160zM320 144C320 218.1 264 279.2 192 287.1V496C192 504.8 184.8 512 176 512C167.2 512 160 504.8 160 496V287.1C88 279.2 32 218.1 32 144C32 64.47 96.47 0 176 0C255.5 0 320 64.47 320 144zM176 256C237.9 256 288 205.9 288 144C288 82.14 237.9 32 176 32C114.1 32 64 82.14 64 144C64 205.9 114.1 256 176 256z",
    },
  ];
  selectedMarker = this.mapMarkers[0];
  markers: any = [];
  menu = false;
  markerColor = "#45ca58";
  linkImage = "http://ultratech.de/application/files/4516/1875/2224/logo-ultrapixel.png";
  linkUrl = "http://ultratech.de/";

  mounted() {
    this.initmap();
  }

  changeMarker() {
    this.addMarker(this.mapOptions.center);
  }

  resetMarker() {
    for (const marker of this.markers) {
      if (typeof marker.category === "undefined") {
        marker.setMap(null);
      }
    }
  }

  addMarker(location: any) {
    this.resetMarker();
    const MAP_MARKER = {
      path: this.selectedMarker.path,
      scale: 0.06,
      fillColor: this.markerColor,
      fillOpacity: 1,
      strokeColor: "#AB47BC",
      anchor: { x: 12, y: 24 },
    };
    const markerCenter = location;
    const marker = new google.maps.Marker({
      map: this.map,
      position: markerCenter,
      title: "Ultrapixel GbR",
      icon: MAP_MARKER,
    });
    this.markers.push(marker);
  }

  initmap() {
    this.map = new google.maps.Map(
      document.getElementById("map"),
      this.mapOptions
    );
    this.addMarker(this.mapOptions.center);
  }

  getLatLng() {
    if (this.checkAddress()) {
      const address = this.street + " " + this.plz + " " + this.city;
      geocoder.geocode({ address: address }, (results: any, status: any) => {
        if (status === google.maps.GeocoderStatus.OK) {
          this.lat = results[0].geometry.location.lat();
          this.lng = results[0].geometry.location.lng();
        }
        if (this.lat && this.lng) {
          this.mapOptions.center.lat = this.lat;
          this.mapOptions.center.lng = this.lng;
        }
        this.initmap();
      });
    }
  }

  changeZoom() {
    this.map.setZoom(Number(this.zoom));
  }

  changeMapType() {
    this.map.setMapTypeId(this.mapType);
  }

  checkAddress() {
    if (this.street && this.plz && this.city) return true;
  }

  checkForm() {
    this.errors = [];
    if ((!this.lat && !this.lng) || !this.street || !this.plz || !this.city)
      this.errors.push("Komplette Adresse erforderlich");
    if (!this.apiKey) this.errors.push("Google Maps: API-Key erforderlich");
    if (!this.errors.length) return true;
  }

  generateCode() {
    if (this.checkForm()) {
      const width = this.mapWidth ? this.mapWidth + "px" : "100%";
      const height = this.mapHeight + "px";
      // eslint-disable-next-line
      this.generateCodeString = `<div class="ultrapixel-map" style="position:relative;"><a href="`+this.linkUrl+`" target="_blank" style="position:absolute;z-index:100;bottom:5px;left:5px;background:#fff;padding:5px 15px;height:40px;"><img style="height:100%;" src="`+this.linkImage+`"></a><div id="map" style="width:`+width+`;height:`+height+`;"></div><script src="https://maps.googleapis.com/maps/api/js?key=`+this.apiKey+`&callback=initMap&v=weekly" async><\/script></div><script>let map;function initMap(){map=new google.maps.Map(document.getElementById("map"),{center:{lat:`+this.lat+`,lng:`+this.lng+`},zoom:`+this.zoom+`,mapTypeControl:!1,mapTypeId:'`+this.mapType+`'}),icon={path:"`+this.selectedMarker.path+`",fillColor:"`+this.markerColor+`",fillOpacity:1,anchor:new google.maps.Point(0,0),strokeWeight:0,scale:0.06},new google.maps.Marker({position:{lat:`+this.lat+`,lng:`+this.lng+`},map:map,title:"Ultrapixel GbR",icon:icon})}<\/script>`;
    }
  }

  copyCode() {
    let testingCodeToCopy = document.querySelector(
      "#map-code"
    ) as HTMLInputElement;
    testingCodeToCopy!.setAttribute("type", "text");
    testingCodeToCopy.select();
    try {
      var successful = document.execCommand("copy");
      alert("Der Code wurde in Ihre Zwischenablage gespeichert.");
    } catch (err) {
      alert("Oops, unable to copy");
    }
    testingCodeToCopy!.setAttribute("type", "hidden");
    window.getSelection()!.removeAllRanges();
  }

  get swatchStyle() {
    const { markerColor, menu } = this;
    return {
      backgroundColor: markerColor,
      cursor: "pointer",
      height: "30px",
      width: "30px",
      borderRadius: menu ? "50%" : "4px",
      transition: "border-radius 200ms ease-in-out",
      margin: "0 0 0 auto",
    };
  }

  @Watch("markerColor")
  onPropertyChanged(value: string, oldValue: string) {
    this.changeMarker();
  }
}
